import cn from 'client/utils/cn';
import LangContext from 'client/utils/lang-context';

import React, { Component } from 'react';

import './index.css';

import Date from 'client/components/date';
import DocsList from 'client/components/docs-list';
import SvgIcon from 'client/components/svg-icon';

import { BunkerFinancialType, BunkerFinancialYear } from 'client/bundles/types';

const b = cn('financials-list');

interface Props {
    financials: BunkerFinancialYear;
}

class FinancialsList extends Component<Props> {
    static contextType = LangContext;

    onItemClick = (url: string) => {
        window.document.location.href = url;
    }

    onDocsClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
    }

    renderItem = (key: BunkerFinancialType) => {
        const { financials } = this.props;
        const { lang, dictionary } = this.context;

        if (!financials) {
            return null;
        }

        const item = financials[key];
        const { date, docs, url } = item;

        let title = key;
        const isLangRu = lang === 'ru';

        if (isLangRu && key.startsWith('q')) {
            title = `${key.replace('q', '')} ${dictionary.quarter}`;
        }

        return (
            <article
                key={url}
                className={b('item')}
                /* eslint-disable-next-line react/jsx-no-bind */
                onClick={() => url && this.onItemClick(url)}
                >
                <div className={b('top')}>
                    <h2 className={b('title', { uppercase: !isLangRu })}>
                        <a
                            className={b('title-link')}
                            // @ts-ignore
                            href={url}
                            >
                            {title}
                            {
                                url && <i className={b('icon')}><SvgIcon icon="arrow" /></i>
                            }
                        </a>
                    </h2>
                </div>

                {
                    // @ts-ignore
                    docs.length > 0 &&
                        <div className={b('center')}>
                            <div className={b('docs')} onClick={this.onDocsClick}>
                                {
                                    // @ts-ignore
                                    <DocsList theme={'gray'} docs={docs} />
                                }
                            </div>
                        </div>
                }

                <div className={b('bottom')}>
                    <div className={b('date')}>
                        {
                            // @ts-ignore
                            <Date dateStart={date} />
                        }
                    </div>
                </div>
            </article>
        );
    }

    render() {
        return (
            <div className={b()}>
                { Object.keys(this.props.financials).map(this.renderItem) }
            </div>
        );
    }

}

export default FinancialsList;
